var _path, _g, _circle, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildEquity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 308,
    viewBox: "0 0 355 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2859 95.0455C58.7599 60.127 114.341 70.8027 161.307 76.9592C224.425 85.2331 307.515 78.2721 328.308 132.801C350.825 191.851 289.255 235.004 229.3 255.265C183.179 270.851 129.638 248.154 88.9718 213.683C49.641 180.343 20.2831 132.854 40.2859 95.0455Z",
    fill: "#FCECD9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_1879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.997 232.999H95.997V130.944L174.499 67.9985L252.997 130.944V232.999Z",
    fill: "#FFE0BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.026 86.8341C194.026 70.3073 222.941 35.6639 251.85 40.991C251.85 40.991 241.951 50.7689 238.076 60.541C234.201 70.3132 222.941 89.4338 194.026 86.8457",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.026 155.831V86.8341C194.026 70.3073 222.941 35.6639 251.85 40.991C251.85 40.991 241.951 50.7689 238.076 60.541C234.201 70.3132 222.941 89.4338 194.026 86.8457",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.291 57.5117C218.278 60.2449 200.068 76.1971 194.026 86.8339",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.026 108.682C194.026 108.682 185.993 78.8722 145.105 78.9303C145.105 78.9303 154.952 84.3792 157.848 93.7683C161.746 106.239 179.824 119.754 194.026 108.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.026 108.682C194.026 108.682 185.993 78.8722 145.105 78.9303C145.105 78.9303 154.952 84.3792 157.848 93.7683C161.746 106.239 179.824 119.754 194.026 108.682Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.9 87.6987C181.404 94.5984 194.02 108.682 194.02 108.682",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.772 171.09C288.772 171.09 293.012 169.262 295.143 166.987C295.954 166.122 293.226 159.17 285.922 159.17C282.881 159.17 273.179 162.6 269.252 163.917C273.382 161.712 277.112 159.17 277.112 159.17C277.448 154.429 271.766 152.207 267.879 152.207C265.279 152.207 258.612 153.547 249.924 156.576C249.924 156.576 252.409 154.778 252.339 154.371C251.181 147.53 240.395 149.201 226.037 156.164C210.82 163.592 195.865 172.14 195.865 172.575C182.369 163.871 169.452 157.871 158.575 157.871L43.297 157.871C43.297 157.871 48.4999 169 57.9999 181.5C70.7627 198.293 79.9999 205.769 79.9999 205.769L125.542 205.35C143.799 205.35 175.529 224.5 202.48 224.5C229.865 224.059 298.126 192.584 305.5 175.279C305.5 175.291 305.419 168.107 288.772 171.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M261.233 201.482C237.763 211.928 214.241 218.601 203.809 218.601C189.908 218.601 174.269 214.667 160.367 209.896C147.329 205.504 136.463 204.79 126.9 204.79C145.157 204.79 176.887 223.94 203.838 223.94C230.789 223.94 306.424 188.652 306.424 175.16C306.424 174.284 306.424 173.419 305.989 173.007C303.354 179.06 287.315 189.708 261.233 201.482Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M222.94 201.482C212.074 201.482 179.041 199.544 160.784 183.418C197.808 197.345 215.961 197.972 230.493 197.217C230.563 196.939 231.883 195.192 231.883 194.757L234.247 194.496C234.247 198.407 228.593 201.459 225.112 201.459L222.94 201.482Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M233.274 181.59C243.266 175.926 254.08 168.574 270.164 163.781C269.73 163.781 278.024 159.475 278.024 159.034C275.412 159.475 271.184 159.91 267.274 160.775C249.898 165.121 229.7 178.265 229.7 178.265C231.177 178.903 231.965 180.713 233.274 181.59Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M295.969 165.249C277.712 168.284 243.798 186.935 232.063 189.528C232.5 190.944 232.5 192.459 232.063 193.875C232.063 194.316 232.15 194.356 232.15 194.797C234.835 194.832 237.488 194.215 239.883 192.999C264.662 181.265 281.616 173.402 292.482 169.932C296.056 166.851 295.534 167.843 295.969 165.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4998 205.214H126.437C144.694 205.214 176.423 224.363 203.375 224.363C218.718 224.363 251.241 212.757 275.325 199.579C299.542 186.36 306.545 176.518 306.545 176.518C306.545 176.518 309.256 154.386 243.028 191.49C240.421 192.807 235.104 194.588 232.063 194.588",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.291 184.439C239.455 177.934 268.63 162.504 282.473 160.026C290.316 158.622 295.338 161.837 296.056 166.868C294.567 168.325 292.839 169.515 290.947 170.384L289.667 170.965",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.584 178.787C237.798 157.897 262.71 152.094 268.768 152.094C272.713 152.094 278.743 154.839 278.001 159.057C278.001 159.057 273.298 162.057 270.141 163.804",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.847 156.463C251.264 156.312 253.251 154.258 253.251 154.258C251.977 147.161 240.508 149.477 226.109 156.458C219.245 159.678 210.151 165.249 210.151 165.249",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.168 194.304C234.838 194.229 237.508 194.211 239.889 193.01L243.028 191.507C243.028 191.507 233.761 182.002 231.617 179.994C229.474 177.986 227.459 176.396 224.302 175.393C221.145 174.389 213.83 168.191 211.675 166.45C202.558 159.144 202.639 159.551 201.203 159.121C199.766 158.692 195.752 155.813 194.026 155.813C192.3 155.813 189.583 158.402 189.004 158.976C188.425 159.551 182.946 163.282 181.799 164.431",
    fill: "#BCB9B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.168 194.304C234.838 194.229 237.508 194.211 239.889 193.01L243.028 191.507C243.028 191.507 233.761 182.002 231.617 179.994C229.474 177.986 227.459 176.396 224.302 175.393C221.145 174.389 213.83 168.191 211.675 166.45C202.558 159.144 202.639 159.551 201.203 159.121C199.766 158.692 195.752 155.813 194.026 155.813C192.3 155.813 189.583 158.402 189.004 158.976C188.425 159.551 182.946 163.282 181.799 164.431",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9998 157.746L159.499 157.746C178.19 157.746 190.342 172.949 215.104 179.495C240.74 186.575 230.494 197.205 230.494 197.205C223.972 198.035 199.465 198.656 160.784 183.406",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M252.353 152.094C241.649 154.85 223.972 164.762 215.556 169.595C217.125 170.837 218.892 172.189 220.52 173.292C232.37 164.843 241.534 159.69 250.847 156.463L253.263 154.258C253.2 153.458 252.881 152.699 252.353 152.094Z",
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9971,
    cy: 67.999,
    r: 32,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.975 77.311C59.779 77.311 58.6957 77.103 57.725 76.687C56.7543 76.2537 55.9743 75.595 55.385 74.711C54.7956 73.827 54.4836 72.7177 54.449 71.383H57.725C57.7423 72.267 58.0283 73.0124 58.583 73.619C59.155 74.2084 59.9523 74.503 60.975 74.503C61.9457 74.503 62.691 74.2344 63.211 73.697C63.731 73.1597 63.991 72.4837 63.991 71.669C63.991 70.7157 63.6443 69.9964 62.951 69.511C62.275 69.0084 61.3997 68.757 60.325 68.757H58.973V66.027H60.351C61.235 66.027 61.9716 65.819 62.561 65.403C63.1503 64.987 63.445 64.3717 63.445 63.557C63.445 62.881 63.2197 62.3437 62.769 61.945C62.3357 61.529 61.729 61.321 60.949 61.321C60.0996 61.321 59.4323 61.5724 58.947 62.075C58.479 62.5777 58.219 63.193 58.167 63.921H54.917C54.9863 62.2397 55.567 60.9137 56.659 59.943C57.7683 58.9724 59.1983 58.487 60.949 58.487C62.197 58.487 63.2457 58.7124 64.095 59.163C64.9617 59.5964 65.6117 60.177 66.045 60.905C66.4956 61.633 66.721 62.439 66.721 63.323C66.721 64.3457 66.435 65.2124 65.863 65.923C65.3083 66.6164 64.615 67.0844 63.783 67.327C64.8057 67.535 65.6377 68.0377 66.279 68.835C66.9203 69.615 67.241 70.603 67.241 71.799C67.241 72.8044 66.9983 73.723 66.513 74.555C66.0277 75.387 65.317 76.0544 64.381 76.557C63.4623 77.0597 62.327 77.311 60.975 77.311Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_1879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 211,
    fill: "white",
    transform: "translate(32.997 39.9985)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildEquity);
export default __webpack_public_path__ + "static/media/BuildEquity.399a459238f1dcf96677458cf20fa2e5.svg";
export { ForwardRef as ReactComponent };